<template>
  <div>
    <div class="images-container">
      <div class="d-flex flex-wrap block" v-if="!isEmpty">
        <div v-for="(item, index) in listImage" :key="index">
          <div class="image-box">
            <el-image
              style="width: 100%; height: 100%"
              fit="scale-down"
              :src="item.displayImageUrl"
              :preview-src-list="listImageUrl"
            ></el-image>
            <div class="shadow">
              <div>
                <span @click="onImagePreview(index)">
                  <i class="el-icon-zoom-in"></i
                ></span>
                <span @click="onImageCheck(item)" class="ml-2">
                  <i class="el-icon-check"></i
                ></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isEmpty" class="empty-image">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </div>
    </div>
    <div v-show="false" class="imagesViewer" v-viewer="{ movable: true }">
      <img
        v-for="item in listImageUrl"
        :src="item || '/image/static/img/nopic.jpg'"
        :key="item"
      />
    </div>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: { fabricCode: { type: String, default: '' } },
  data() {
    return {
      listImage: [],
    }
  },
  computed: {
    isEmpty() {
      return !this.listImage || !this.listImage.length
    },
    listImageUrl() {
      return this.isEmpty
        ? []
        : this.listImage.map((item) => item.displayImageUrl)
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.fabricCode) return
      const res = await this.$api
        .masterFabricImageListApi({ fabricCode: this.fabricCode })
        .catch(() => null)
      this.listImage = res.body.data
    },
    onImagePreview(index) {
      if (this.isEmpty) return
      const viewer = this.$el.querySelector('.imagesViewer').$viewer
      viewer.view(index)
      viewer.show()
    },
    onImageCheck({ displayImageCode, displayImageUrl }) {
      this.$emit('check', { displayImageCode, displayImageUrl })
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
}

.images-container {
  height: 825px;
}

.empty-image {
  height: 825px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-box {
  width: 140px;
  height: 140px;
  line-height: 140px;
  position: relative;
  background-color: #fbfdff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  margin: 8px;
  position: relative;
  .default-icon {
    position: absolute;
    z-index: 999;
    right: 0;
    display: flex;
    align-items: flex-start;
    color: #20c997;
  }
}
.image-box:hover {
  .shadow {
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 1;
  }
}

.shadow {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  border-radius: 6px;
  opacity: 0;
  transition: opacity 0.3s;
  color: #fff;
  font-size: 20px;
  line-height: 20px;
  padding: 2px;
}
</style>
